import { render, staticRenderFns } from "./TasksWorkload.vue?vue&type=template&id=ad606f4c&scoped=true"
import script from "./TasksWorkload.vue?vue&type=script&lang=js"
export * from "./TasksWorkload.vue?vue&type=script&lang=js"
import style0 from "./TasksWorkload.vue?vue&type=style&index=0&id=ad606f4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad606f4c",
  null
  
)

export default component.exports